// Quando cada tela foi aberta pela última vez neste navegador — usado pra
// ordenar os "Acessos rápidos" do painel inicial (as abertas mais
// recentemente primeiro). Guarda só a rota base (ex: '/venda/12' conta como
// '/venda').

const CHAVE_ULTIMOS_ACESSOS = 'APP_ULTIMOS_ACESSOS';

export const rotaBase = (pathname: string) => `/${pathname.split('/').filter(Boolean)[0] ?? ''}`;

// Rota base -> momento do último acesso (ms).
export const obterUltimosAcessos = (): Record<string, number> => {
  try {
    return JSON.parse(localStorage.getItem(CHAVE_ULTIMOS_ACESSOS) || '{}');
  } catch {
    return {};
  }
};

export const registrarAcesso = (pathname: string) => {
  const rota = rotaBase(pathname);
  if (rota === '/' || rota === '/inicio') return;
  try {
    const acessos = obterUltimosAcessos();
    acessos[rota] = Date.now();
    localStorage.setItem(CHAVE_ULTIMOS_ACESSOS, JSON.stringify(acessos));
  } catch {
    // localStorage indisponível — os atalhos só ficam na ordem padrão.
  }
};
